import { useQuery } from '@tanstack/react-query';
import { reservationOptions } from '../../constants/reservations';
const DEFAULT_SCOPE = {
    withParking: true,
    withVehicle: true,
    withSpot: true,
    withRenterBilling: true,
    withOrder: true,
};
export function useReservation(id, scope) {
    const { data, isLoading, isSuccess } = useQuery(reservationOptions.get({ id }, scope ?? DEFAULT_SCOPE));
    return {
        reservation: data?.[0],
        loadingReservation: isLoading,
        isSuccess,
    };
}
